import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=c5302a74&"
import script from "./IssueList.vue?vue&type=script&lang=ts&"
export * from "./IssueList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports